import React from "react";
import { AuditLog } from "@common/types/auditLog";
import { formatDuration } from "@design-system/TimePicker/TimePicker.lib";
import styles from "./ChatTaskAuditLog.module.scss";

interface Props {
    log: AuditLog;
}

export const ChatTaskEstimatedTime: React.FC<Props> = ({ log }) => {
    const rawEstimatedTime = log.diff.find((d) => d.field === "estimatedTime")
        ?.after?.value;
    const newEstimatedTime =
        typeof rawEstimatedTime === "string"
            ? Number(rawEstimatedTime)
            : rawEstimatedTime;
    const formattedEstimate =
        typeof newEstimatedTime === "number" &&
        Number.isFinite(newEstimatedTime)
            ? formatDuration(newEstimatedTime)
            : "";

    if (
        newEstimatedTime === undefined ||
        newEstimatedTime === null ||
        !formattedEstimate
    ) {
        return (
            <>
                <span className={styles.chatTaskMessage}>
                    removed the estimate
                </span>
            </>
        );
    }

    return (
        <>
            <span className={styles.chatTaskMessage}>
                changed the estimate to&nbsp;
                <strong>{formattedEstimate}</strong>
            </span>
        </>
    );
};
